import spotAbi from 'blockchain/abi/mcd-spot.json';
import Web3 from 'web3';
import { BigNumber } from 'bignumber.js';
import { MULTICHAIN_SETUP } from 'constants/variables';
import { Ilks } from 'types';
import { amountFromRay } from 'utils/contract/common-function';
import { initialContract } from 'utils/contract/web3';

const { MCD_SPOT } = MULTICHAIN_SETUP.polka.address;

export const spotIlks$ = async ({ ilks }: Ilks, rpc?: string) => {
  const spot = initialContract(spotAbi, MCD_SPOT, rpc);
  const { pip, mat } = await spot.methods
    .ilks(Web3.utils.utf8ToHex(ilks))
    .call();

  return {
    priceFeedAddress: pip,
    liquidationRatio: amountFromRay(new BigNumber(mat)),
  };
};
